import { render, staticRenderFns } from "./MdProductItem.vue?vue&type=template&id=f4ce40f0&scoped=true&"
import script from "./MdProductItem.vue?vue&type=script&lang=js&"
export * from "./MdProductItem.vue?vue&type=script&lang=js&"
import style0 from "./MdProductItem.vue?vue&type=style&index=0&id=f4ce40f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4ce40f0",
  null
  
)

export default component.exports